import { db } from './config';
import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';

const collectionName = "settings";

// Yeni lüks tasarıma uygun varsayılan vitrin (Landing) ayarları
export const defaultSettings = {
    hero: {
        eyebrow: 'ZİRVE DÖKÜM · İSTANBUL',
        title: 'Ustalıkla\nşekillenen\ndeğer.',
        subtitle: 'Tasarımınızın her detayına aynı özen.\nDeğerli maden dökümünde, ilk modelden son parçaya kadar yanınızdayız.',
        note: 'Sizin başarınız,\nbizim başarımız.',
        features: [
            'Detayda hassasiyet',
            'Üretimde özen',
            'Süreçte şeffaflık'
        ]
    },
    about: {
        eyebrow: 'BİZİ TANIYIN',
        title: 'İşinizin arkasındaki\nustalık.',
        description1: 'Her tasarımın bir emeği, her parçanın bir hikâyesi var. Zirve Döküm olarak, o emeği üretimin her aşamasında aynı titizlikle ele alıyoruz.',
        description2: 'Değerli maden dökümü, mum basımı ve kalıp kesimi hizmetlerimizle kuyumculuk üretiminize eşlik ediyoruz. Çarşı ve Kuyumcukent şubelerimizde sizinle tanışmayı bekliyoruz.',
        image: '/assets/atelier.jpg'
    },
    services: {
        eyebrow: 'UZMANLIĞIMIZ',
        title: 'Fikirden forma,\nher adımda Zirve.',
        subtitle: 'Tasarımınıza hayat veren hizmetler.\nİhtiyacınıza uygun üretim için birlikte çalışalım.',
        items: [
            {
                code: '01 / DÖKÜM',
                title: 'Değerli Maden Dökümü',
                description: 'Özel tasarımlarınız ve seri üretimleriniz için detaylara özen gösteren döküm hizmeti.',
                cta: 'Tasarımınız, ustalığımızla buluşsun',
                image: '/assets/casting 2.png'
            },
            {
                code: '02 / MODEL',
                title: '3D Mum Basımı',
                description: 'Dijital tasarımlarınızı döküme hazırlayan, modelin detaylarını öne çıkaran mum basımı.',
                cta: 'İlk adım, doğru model',
                image: '/assets/wax 1.png'
            },
            {
                code: '03 / KALIP',
                title: 'Kalıp Kesimi',
                description: 'Üretimde devamlılık için modelinize uygun, titizlikle hazırlanan kalıp çözümleri.',
                cta: 'Her üretime sağlam bir başlangıç',
                image: '/assets/molding 1.png'
            }
        ]
    },
    contact: {
        eyebrow: 'BİRLİKTE ÜRETELİM',
        title: 'Bir sonraki tasarımınız\nburada hayat bulsun.',
        callPhone: '+905058740294',
        branches: [
            {
                name: '01 / ÇARŞI ŞUBE',
                heading: 'Üretimin kalbinde.',
                address: 'Mollafenari Mh. Adem Yavuz Sk. No: 18 Kat: 3\nYenice İşhanı, Fatih / İstanbul',
                phone: '+90 505 874 02 94',
                mapUrl: 'https://www.google.com/maps?ll=41.011092,28.972489&z=15&t=m&hl=tr&gl=TR&mapclient=embed&cid=8517833235626735810'
            },
            {
                name: '02 / KUYUMCUKENT ŞUBE',
                heading: 'İşinize yakın.',
                address: 'Kuyumcukent Kompleksi, Atölye Bloğu\n3. Kat, 1. Sokak No: 2, Bahçelievler / İstanbul',
                phone: '+90 535 254 10 01',
                mapUrl: 'https://www.google.com/maps?ll=41.002607,28.819381&z=15&t=m&hl=tr&gl=TR&mapclient=embed&cid=3857569478239068333'
            }
        ],
        email: 'info@zirvedokum.com',
        workingHours: ['Pazartesi–Cuma · 09.00–19.00', 'Cumartesi · 09.00–15.00']
    }
};

// Ayarları gerçek zamanlı dinle (Landing Page ve Ayarlar için)
export const getSettings = (callback) => {
    const settingsRef = doc(db, collectionName, 'home');

    return onSnapshot(settingsRef, (snapshot) => {
        if (snapshot.exists()) {
            const data = snapshot.data();
            // Varsayılan değerlerle birleştir (eksik alan varsa varsayılan gelsin)
            callback({
                ...defaultSettings,
                ...data,
                hero: { ...defaultSettings.hero, ...(data.hero || {}) },
                about: { ...defaultSettings.about, ...(data.about || {}) },
                services: { ...defaultSettings.services, ...(data.services || {}) },
                contact: { ...defaultSettings.contact, ...(data.contact || {}) },
            });
        } else {
            callback(defaultSettings);
        }
    }, (error) => {
        console.warn("Firestore settings/home okunamadı, varsayılan ayarlar kullanılıyor:", error);
        callback(defaultSettings);
    });
};

// Ayarları bir kez getir
export const loadSettings = async () => {
    try {
        const settingsRef = doc(db, collectionName, 'home');
        const snapshot = await getDoc(settingsRef);

        if (snapshot.exists()) {
            const data = snapshot.data();
            return {
                ...defaultSettings,
                ...data,
                hero: { ...defaultSettings.hero, ...(data.hero || {}) },
                about: { ...defaultSettings.about, ...(data.about || {}) },
                services: { ...defaultSettings.services, ...(data.services || {}) },
                contact: { ...defaultSettings.contact, ...(data.contact || {}) },
            };
        }
    } catch (e) {
        console.warn("Firestore settings/home getDoc hatası:", e);
    }
    return defaultSettings;
};

// Ayarları kaydet
export const saveSettings = async (settings) => {
    const settingsRef = doc(db, collectionName, 'home');
    await setDoc(settingsRef, settings, { merge: true });
};

// İlk kurulum için varsayılan ayarları kaydet
export const initializeDefaultSettings = async () => {
    const settingsRef = doc(db, collectionName, 'home');
    const snapshot = await getDoc(settingsRef);

    if (!snapshot.exists()) {
        await setDoc(settingsRef, defaultSettings);
    }
};
